<template>
  <transition name="modal">
    <div class="modal-mask select-graphics-template-modal">
      <div class="modal-wrapper" v-on:click.self="$emit('close')">
        <div class="modal-container">
          <div class="modal-header">
            <div class="title">Choose from your existing Graphic templates</div>
            <button v-on:click="$emit('close')" class="modal-close tb-btn tb-btn-text sm low-em" data-test="producer-savedGraphicsModal-close"><span class="icon icon-cross"></span></button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loading"><i class="icon icon-spinner"></i></div>
            <template v-else>
              <div class="filter-bar filter-graphic-templates">
                <div class="tb-form-group">
                  <i class="icon icon-magnifier"></i>
                  <input-tag v-on:add="addTag" placeholder="Filter Graphic templates" v-on:remove="removeTag" :tags="searchTerms" data-test="producer-savedGraphicsModal-search"></input-tag>
                </div>
              </div>
              <templates-table v-on:select="setSelected" :selected="selected" :templates="searchResults"></templates-table>
            </template>
          </div>
          <div class="modal-footer">
            <button class="tb-btn tb-btn-text medium-em" data-test="producer-savedGraphicsModal-cancel" v-on:click="$emit('close')">Cancel</button>
            <button v-on:click="selectTemplate" v-bind:disabled="!selected" v-bind:class="{'disabled': !selected }" class="tb-btn tb-btn-contained high-em" data-test="producer-savedGraphicsModal-select">Select</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { filter, some, findIndex, pick } from 'lodash-es';
import TemplatesTableComponent from '../templates-table/TemplatesTable.vue';

export default {
  components: {
    'templates-table': TemplatesTableComponent,
  },
  data() {
    return {
      selected: null,
      searchTerms: [],
      searchResults: [],
    };
  },
  created() {
    this.$store.dispatch('getTemplates').then(() => {
      this.doSearch();
    });
  },
  computed: {
    templates() {
      return this.$store.state.graphics.templates;
    },
    loading() {
      return this.$store.state.production.loading;
    },
  },
  methods: {
    doSearch() {
      if (!this.searchTerms.length) {
        this.searchResults = this.templates;
        return;
      }

      this.searchResults = filter(this.templates, (template) => {
        const tagFound = some(this.searchTerms, (term) => some(template.tags, (tag) => tag.toLowerCase().indexOf(term.toLowerCase()) !== -1));

        const titleFound = some(this.searchTerms, (term) => template.title.toLowerCase().indexOf(term.toLowerCase()) !== -1);

        return tagFound || titleFound;
      });
    },
    addTag(tag) {
      if (this.searchTerms.indexOf(tag) === -1) {
        this.searchTerms.push(tag);
        this.doSearch();
      }
    },
    removeTag(tag) {
      const index = findIndex(this.searchTerms, (o) => o === tag);
      this.searchTerms.splice(index, 1);
      this.doSearch();
    },
    setSelected(template) {
      this.selected = template;
    },
    selectTemplate() {
      const graphic = pick(this.selected, ['title', 'owner']);

      graphic.template_id = this.selected._id;
      graphic.production_id = this.$store.state.production.production._id;
      graphic.fields = {};

      this.$store.dispatch('createGraphic', { graphic }).then(() => {
        this.successToast('Graphic saved successfully.');
        this.$emit('close');
      }).catch(() => {
        this.errorToast('There was an error saving your graphic. Please try again.');
      });
    },
  },
};
</script>
